import { useState } from "react";
import { PlusIcon } from "@heroicons/react/24/outline";
import Select from "components/ui/Select";
import SetGroup from "components/groups/SetGroup";
import { useAllPartySupMasts } from "http-hooks/partysupmast/usepartysupmast";

const SelectGroups = ({
  value,
  onChange,
  type = "",
  placeholder = "Select account group (optional)",
  isDisabled = false,
  isRequired = false,
  label = "Account Group",
  className = "",
  showAddButton = true,
  isClearable = true,
}) => {
  const [showAddModal, setShowAddModal] = useState(false);

  const { isLoading, data: { data: allGroups } = {} } = useAllPartySupMasts({
    level: 1,
    ...(type ? { type } : {}),
    noPagination: true,
  });

  const options = (allGroups || []).map((g) => ({
    value: g.grpId,
    label: g.name,
  }));

  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <label className="block text-sm font-medium leading-6 text-gray-900">
          {label} {isRequired && <span className="text-red-500">*</span>}
        </label>
        {showAddButton && !isDisabled && (
          <button
            type="button"
            onClick={() => setShowAddModal(true)}
            className="ml-2 p-1 text-xs font-bold bg-black text-white rounded hover:bg-gray-800 transition-colors duration-200 flex items-center"
            title="Add new group"
          >
            <PlusIcon className="h-3 w-3" aria-hidden="true" />
          </button>
        )}
      </div>

      <Select
        value={options.find((o) => o.value === value) || null}
        onChange={(option) => onChange(option?.value || "")}
        options={options}
        placeholder={placeholder}
        isDisabled={isDisabled}
        isLoading={isLoading}
        isRequired={isRequired}
        className={className}
        showLabel={false}
        isClearable={isClearable}
        isSearchable={true}
      />

      {showAddModal && (
        <SetGroup
          id={null}
          open={showAddModal}
          onClose={() => setShowAddModal(false)}
          defaultType={type}
        />
      )}
    </div>
  );
};

export default SelectGroups;
